/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PRPTemplatesDocument } from './pRPTemplatesDocument';
import { TemplatizeTabResponse } from './templatizeTabResponse';


export interface TemplatizeDocumentResponse { 
    documentTemplate?: PRPTemplatesDocument;
    tabTemplates?: Array<TemplatizeTabResponse> | null;
}

